import React, { Component } from 'react';
import SalesTableContainer from './SalesTableContainer';

class AdminSalesPage extends Component {
	render() {
		return (
			<div className="animated fadetwoIn dnp-page">
				<SalesTableContainer />
			</div>
		);
	}
}

export default AdminSalesPage;